/**
 * Wrapper for an asynchronous function that limits calls so that if the
 * function is called again before the first promise resolves, the same promise
 * is returned as opposed to calling the wrapped function again.
 */ import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
export var throttlePromise = function(asyncFunc) {
    var lastRequest;
    return /*#__PURE__*/ _async_to_generator(function() {
        var resetLastRequest;
        return _ts_generator(this, function(_state) {
            if (lastRequest) {
                return [
                    2,
                    lastRequest
                ];
            }
            lastRequest = asyncFunc();
            resetLastRequest = function() {
                lastRequest = undefined;
            };
            lastRequest.then(resetLastRequest).catch(resetLastRequest);
            return [
                2,
                lastRequest
            ];
        });
    });
};
